import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSubscriptionContext } from '../../contexts/SubscriptionContext';
import { isClientRole } from '../../auth/roleUtils';
import { FiAlertTriangle, FiX } from 'react-icons/fi';

const STATUS_MESSAGES = {
    PastDue: {
        title: 'Payment Failed',
        message: 'Your payment failed. Please update your payment method to continue using Sena.',
    },
    Canceled: {
        title: 'Subscription Ended',
        message: 'Your subscription has ended. Please resubscribe to regain access.',
    },
    Incomplete: {
        title: 'Setup Incomplete',
        message: 'Your subscription setup is incomplete. Please complete the checkout process.',
    },
    None: {
        title: 'Subscription Required',
        message: 'Please subscribe to a plan to access this feature.',
    },
};

export default function PaywallModal() {
    const { paywallStatus, dismissPaywall } = useSubscriptionContext();
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const isBillingExemptRoute = pathname.startsWith('/midwife/billing')
        || pathname.startsWith('/midwife/onboarding')
        || pathname === '/midwife/notifications';
    const isClientUser = isClientRole(localStorage.getItem('userRole'));

    useEffect(() => {
        if (isBillingExemptRoute && paywallStatus) {
            dismissPaywall();
        }
    }, [dismissPaywall, isBillingExemptRoute, paywallStatus]);

    if (isClientUser || !paywallStatus || isBillingExemptRoute) return null;

    const info = STATUS_MESSAGES[paywallStatus] || STATUS_MESSAGES.None;

    const handleGoToBilling = () => {
        dismissPaywall();
        navigate('/midwife/billing');
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-xl shadow-xl max-w-md w-full">
                <div className="flex items-center justify-between px-6 pt-5 pb-3 border-b border-gray-100">
                    <div className="flex items-center gap-2">
                        <FiAlertTriangle className="w-5 h-5 text-amber-500" />
                        <h2 className="text-lg font-semibold text-gray-900">{info.title}</h2>
                    </div>
                    <button
                        onClick={dismissPaywall}
                        className="text-gray-400 hover:text-gray-600 transition-colors"
                    >
                        <FiX className="w-5 h-5" />
                    </button>
                </div>

                <div className="px-6 py-5">
                    <p className="text-gray-600">{info.message}</p>
                </div>

                <div className="flex justify-end gap-3 px-6 py-4 border-t border-gray-200">
                    <button
                        onClick={dismissPaywall}
                        className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
                    >
                        Dismiss
                    </button>
                    <button
                        onClick={handleGoToBilling}
                        className="px-4 py-2 text-sm font-medium text-white bg-[#4f7a64] hover:bg-[#3d6350] rounded-lg transition-colors"
                    >
                        Go to Billing
                    </button>
                </div>
            </div>
        </div>
    );
}
